module.exports = __webpack_public_path__ + "img/技术专利.6b965653.png";